import { slateNodesToInsertDelta } from '@slate-yjs/core'
import { defaultEditorValue } from '@tunasong/models'
import { fromUint8Array } from 'js-base64'
import * as Y from 'yjs'
import { getSharedTypeV2 } from './get-shared-type.js'

/**
 * The client ID every seed is authored under. Y.js identifies an item by (clientID, clock), so seeds
 * made under one fixed ID are byte-identical and merge to a single copy. Seeds made under random IDs
 * (as `createCollaborativeDoc` does) would each add their own empty line.
 */
const seedClientId = 0

/**
 * The doc to start from when a collaborative entity was stored without one — e.g. setlists created
 * from the New Entity dialog before GH #2214. Clients open such an entity on this seed and the server
 * merge starts from it too, so edits made on a client's seed apply to the server's.
 */
export const getSeedYDocUpdates = () => {
  const doc = new Y.Doc()
  doc.clientID = seedClientId
  getSharedTypeV2(doc).applyDelta(slateNodesToInsertDelta(defaultEditorValue))
  const updates = Y.encodeStateAsUpdate(doc)
  doc.destroy()
  return updates
}

export const getSeedYDocString = () => fromUint8Array(getSeedYDocUpdates())
